import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { useEffect, useMemo } from "react";
import { FlowActions } from "../../stores/flowStore";
export const useSetTotalUsdPriceFragment = graphql(`
  fragment useSetTotalUsdPrice on ItemQuoteResult {
    __typename
    ... on ItemQuote {
      pricePerItem {
        usd
      }
    }
  }
`);
export function useSetTotalUsdPrice(itemQuoteKeys) {
  const $ = _c(5);
  let t0;
  let t1;
  if ($[0] !== itemQuoteKeys) {
    t1 = itemQuoteKeys?.reduce(_temp, 0);
    $[0] = itemQuoteKeys;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  t0 = t1;
  const totalUsdPrice = t0;
  let t2;
  let t3;
  if ($[2] !== totalUsdPrice) {
    t2 = function setTotalUsdPriceInFlowStore() {
      FlowActions.setFlowField("totalUsdPrice", totalUsdPrice);
    };
    t3 = [totalUsdPrice];
    $[2] = totalUsdPrice;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  return totalUsdPrice;
}
function _temp(acc, itemQuoteKey) {
  const itemQuote = readFragment(useSetTotalUsdPriceFragment, itemQuoteKey);
  if (itemQuote.__typename !== "ItemQuote") {
    return acc;
  }
  return acc + itemQuote.pricePerItem.usd;
}